(function($) {
    $.widget("ca.caDropdownMenu", {
        _create : function() {
            var self = this;
            var select = this.element;
            var id = select.attr('id');

            select.on('click', function() {
                self.toggle(this);
            });
            $(document).on('click', function(event){
                if ($(event.target).parents('#'+id).attr('id') != id) {
                    select.find('.dropdown-menu').hide(200);
                }
            });

            var dropdownLink = select.find('.dropdown-toggle');
            var dropdownMenu = select.find('.dropdown-menu');
            var position = dropdownLink.position().left - dropdownMenu.width() + dropdownLink.innerWidth();
            dropdownMenu.css('left', position );

            $('.can-have-state').on('click', function() {
                var isSelected = $(this).children('input').val();
                var newValue = parseInt(isSelected) ? 0 : 1;
                $(this).children('input').val(newValue);

                var canBeSelected = $(this).find('a').hasClass('can-be-selected');
                if (canBeSelected) {
                    if (newValue) {
                        $(this).addClass('active')
                    } else {
                        $(this).removeClass('active');
                    }
                }
            });
        },

        toggle: function (select) {
            $(select).find('.dropdown-menu').slideToggle(200);
        }
    });
})(jQuery);
